import { render, staticRenderFns } from "./behavioranalysis.vue?vue&type=template&id=bff6a908&scoped=true&"
import script from "./behavioranalysis.vue?vue&type=script&lang=js&"
export * from "./behavioranalysis.vue?vue&type=script&lang=js&"
import style0 from "./behavioranalysis.vue?vue&type=style&index=0&id=bff6a908&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff6a908",
  null
  
)

export default component.exports